import * as Sentry from '@sentry/browser';

function sentryEnvironment(): string {
  if (typeof window === 'undefined') return import.meta.env.DEV ? 'development' : 'unknown';
  const host = window.location.hostname;
  if (host === 'app.agentboardai.com') return 'production';
  if (host.endsWith('.pages.dev')) return 'preview';
  if (host === 'localhost' || host === '127.0.0.1') return 'development';
  return 'self-hosted';
}

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn || import.meta.env.DEV) return;

  Sentry.init({
    dsn,
    environment: sentryEnvironment(),
    sendDefaultPii: false,
    attachStacktrace: true,
    tracesSampleRate: 0,
  });
}
